import { useState } from "react";
import Utils from "../utils/Utils";

const useId = () => {
  const [id] = useState(Utils.getUniqueId());
  return id;
};

export default useId;
